import React from 'react';
import { styled } from '@compiled/react';
import type { CardId } from '../../../../model/types';
import { useBacklogSelector } from '../../../../state';
import { isCmpKanbanProject } from '../../../../state/selectors/app';
import {
	getChildIdsByParentIdSelector,
	makeGetDraggingCardIds,
} from '../../../../state/selectors/cards';
import CardContents from '../card-contents';

export interface CardDragPreviewProps {
	id: CardId;
}

export function CardDragPreview({ id }: CardDragPreviewProps) {
	const isCmpKanbanBacklog = useBacklogSelector(isCmpKanbanProject);
	const getDraggingCardIds = useBacklogSelector(makeGetDraggingCardIds);
	const getChildIdsByParentId = useBacklogSelector(getChildIdsByParentIdSelector);

	return (
		<CardDragPreviewContainer>
			{getDraggingCardIds(id)
				.slice(0, 5)
				.map((contentsId, index) => {
					const subtaskIds = isCmpKanbanBacklog ? [] : getChildIdsByParentId[contentsId];
					return (
						<CardContents
							id={contentsId}
							key={contentsId}
							canShowStatus={false}
							isDragging={index === 0}
							isDragHandle
							shouldRenderRichCard={false}
							isAttachedToParent={false}
							subtaskIds={subtaskIds}
						/>
					);
				})}
		</CardDragPreviewContainer>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CardDragPreviewContainer = styled.div({
	position: 'relative',
	// Going over 270px will break windows rendering of the drag preview
	maxWidth: 260,
});
